<template>
  <section id="hero" class="section hero">
    <div class="section-inner hero-inner">
      <div class="hero-copy">
        <span class="status">
          <span class="status-dot"></span>
          <span class="mono">disponível para novos desafios</span>
        </span>

        <h1 class="hero-name">
          Júlio<span class="hero-name-accent"> César</span>
        </h1>

        <p class="hero-role mono">
          <span class="hero-role-prompt">&gt;</span>
          <span>{{ typed }}</span>
          <span class="caret"></span>
        </p>

        <p class="hero-text">
          Desenvolvedor de software desde <strong>2018</strong>, hoje focado em
          <strong>engenharia de software com IA</strong>: arquitetura de
          agentes, RAG, integração de LLMs e automação de processos inteligentes
          em plataformas SaaS escaláveis.
        </p>

        <div class="hero-actions">
          <a
            class="btn btn--primary"
            href="#projects"
            @click.prevent="goTo('#projects')"
          >
            Ver projetos
          </a>
          <a
            class="btn btn--ghost"
            href="https://github.com/jces4rrr"
            target="_blank"
            rel="noopener"
          >
            <v-icon size="18">mdi-github</v-icon>
            GitHub
          </a>
        </div>

        <dl class="stats">
          <div v-for="stat in stats" :key="stat.label" class="stat">
            <dt class="stat-value">{{ stat.value }}</dt>
            <dd class="stat-label mono">{{ stat.label }}</dd>
          </div>
        </dl>
      </div>

      <aside class="hero-card" aria-hidden="true">
        <div class="card-bar">
          <span class="card-dot"></span>
          <span class="card-dot"></span>
          <span class="card-dot"></span>
          <span class="card-file mono">profile.ts</span>
        </div>

        <pre
          class="code mono"
        ><code><span class="c-key">const</span> <span class="c-var">julio</span>: <span class="c-type">Engineer</span> = {
  <span class="c-prop">foco</span>:      <span class="c-str">"IA aplicada &amp; agentes"</span>,
  <span class="c-prop">desde</span>:     <span class="c-num">2018</span>,
  <span class="c-prop">stack</span>:     [<span class="c-str">"Vue"</span>, <span class="c-str">"Node"</span>, <span class="c-str">"JavaScript"</span>],
  <span class="c-prop">ia</span>:        [<span class="c-str">"LLMs"</span>, <span class="c-str">"RAG"</span>, <span class="c-str">"Agentes"</span>],
  <span class="c-prop">infra</span>:     [<span class="c-str">"Docker"</span>, <span class="c-str">"AWS"</span>, <span class="c-str">"GCP"</span>],
  <span class="c-prop">local</span>:     <span class="c-str">"Caruaru - PE 🇧🇷"</span>,
  <span class="c-prop">buildLoop</span>: () <span class="c-key">=&gt;</span> <span class="c-str">"aprender → entregar"</span>,
};</code></pre>
      </aside>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutPage",

  data() {
    return {
      roles: [
        "Desenvolvedor Fullstack",
        "Engenheiro de Software com IA",
        "Arquiteto de Agentes de IA",
      ],
      typed: "",
      roleIndex: 0,
      charIndex: 0,
      deleting: false,
      timer: null,
      stats: [
        { value: "7+", label: "anos de estrada" },
        { value: "3", label: "formações em eng. de software" },
      ],
    };
  },

  methods: {
    goTo(target) {
      this.$vuetify.goTo(target, {
        duration: 700,
        offset: 0,
        easing: "easeInOutCubic",
      });
    },

    tick() {
      const current = this.roles[this.roleIndex];

      if (!this.deleting) {
        this.charIndex += 1;
        this.typed = current.slice(0, this.charIndex);

        if (this.charIndex === current.length) {
          this.deleting = true;
          this.timer = setTimeout(this.tick, 2200);
          return;
        }
      } else {
        this.charIndex -= 1;
        this.typed = current.slice(0, this.charIndex);

        if (this.charIndex === 0) {
          this.deleting = false;
          this.roleIndex = (this.roleIndex + 1) % this.roles.length;
        }
      }

      this.timer = setTimeout(this.tick, this.deleting ? 35 : 70);
    },
  },

  mounted() {
    const reduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduced) {
      this.typed = this.roles[0];
      return;
    }

    this.timer = setTimeout(this.tick, 500);
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
